// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3TWyr","info":"PatientInfo_info__3mMRR"};